/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */

import { Contract, ContractFactory, Signer } from "ethers";
import { Provider } from "ethers/providers";
import { UnsignedTransaction } from "ethers/utils/transaction";

import { ZkSync } from "./ZkSync";

export class ZkSyncFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(): Promise<ZkSync> {
    return super.deploy() as Promise<ZkSync>;
  }
  getDeployTransaction(): UnsignedTransaction {
    return super.getDeployTransaction();
  }
  attach(address: string): ZkSync {
    return super.attach(address) as ZkSync;
  }
  connect(signer: Signer): ZkSyncFactory {
    return super.connect(signer) as ZkSyncFactory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ZkSync {
    return new Contract(address, _abi, signerOrProvider) as ZkSync;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint32",
        name: "blockNumber",
        type: "uint32"
      }
    ],
    name: "BlockCommit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint32",
        name: "blockNumber",
        type: "uint32"
      }
    ],
    name: "BlockVerification",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "totalBlocksVerified",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "totalBlocksCommitted",
        type: "uint32"
      }
    ],
    name: "BlocksRevert",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint32",
        name: "zkSyncBlockId",
        type: "uint32"
      },
      {
        indexed: true,
        internalType: "uint32",
        name: "accountId",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "tokenId",
        type: "uint16"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      }
    ],
    name: "DepositCommit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "ExodusMode",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "fact",
        type: "bytes"
      }
    ],
    name: "FactAuth",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint32",
        name: "zkSyncBlockId",
        type: "uint32"
      },
      {
        indexed: true,
        internalType: "uint32",
        name: "accountId",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "tokenId",
        type: "uint16"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      }
    ],
    name: "FullExitCommit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "serialId",
        type: "uint64"
      },
      {
        indexed: false,
        internalType: "enum Operations.OpType",
        name: "opType",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "pubData",
        type: "bytes"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expirationBlock",
        type: "uint256"
      }
    ],
    name: "NewPriorityRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "tokenId",
        type: "uint16"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OnchainDeposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "tokenId",
        type: "uint16"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      }
    ],
    name: "OnchainWithdrawal",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "queueStartIndex",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "queueEndIndex",
        type: "uint32"
      }
    ],
    name: "PendingWithdrawalsAdd",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "queueStartIndex",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "queueEndIndex",
        type: "uint32"
      }
    ],
    name: "PendingWithdrawalsComplete",
    type: "event"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint104",
        name: "_amount",
        type: "uint104"
      },
      {
        internalType: "address",
        name: "_franklinAddr",
        type: "address"
      }
    ],
    name: "depositERC20",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "_amount",
        type: "uint128"
      },
      {
        internalType: "address",
        name: "_addr",
        type: "address"
      }
    ],
    name: "withdrawERC20",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610d31806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806399e3644a1461003b578063e17376b5146100bb575b600080fd5b6100b96004803603606081101561005157600080fd5b81019080803573ffffffffffffffffffffffffffffffffffffffff16906020019092919080356fffffffffffffffffffffffffffffffff169060200190929190803573ffffffffffffffffffffffffffffffffffffffff169060200190929190505050610138565b005b610136600480360360608110156100d157600080fd5b81019080803573ffffffffffffffffffffffffffffffffffffffff16906020019092919080356cffffffffffffffffffffffffff169060200190929190803573ffffffffffffffffffffffffffffffffffffffff1690602001909291905050506101cc565b005b6101558382846fffffffffffffffffffffffffffffffff16610424565b6101c7576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004018080602001828103825260058152602001807f777467313100000000000000000000000000000000000000000000000000000081525060200191505060405180910390fd5b505050565b60006010905060008473ffffffffffffffffffffffffffffffffffffffff166370a08231306040518263ffffffff1660e01b8152600401808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060206040518083038186803b15801561025157600080fd5b505afa158015610265573d6000803e3d6000fd5b505050506040513d602081101561027b57600080fd5b810190808051906020019092919050505090506102c38533306102ac886cffffffffffffffffffffffffff166105ec565b6fffffffffffffffffffffffffffffffff1661065f565b610335576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004018080602001828103825260058152602001807f666430313200000000000000000000000000000000000000000000000000000081525060200191505060405180910390fd5b60008573ffffffffffffffffffffffffffffffffffffffff166370a08231306040518263ffffffff1660e01b8152600401808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060206040518083038186803b1580156103b457600080fd5b505afa1580156103c8573d6000803e3d6000fd5b505050506040513d60208110156103de57600080fd5b81019080805190602001909291905050509050600061040e610409848461085c90919063ffffffff16565b6105ec565b905061041b8482876108a6565b50505050505050565b60008060608573ffffffffffffffffffffffffffffffffffffffff168585604051602401808373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001828152602001925050506040516020818303038152906040527fa9059cbb000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19166020820180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff83818316178352505050506040518082805190602001908083835b602083106105355780518252602082019150602081019050602083039250610512565b6001836020036101000a0380198251168184511680821785525050505050509050019150506000604051808303816000865af19150503d8060008114610597576040519150601f19603f3d011682016040523d82523d6000602084013e61059c565b606091505b5091509150600080825114806105d457508180602001905160208110156105c257600080fd5b81019080805190602001909291905050505b90508280156105e05750805b93505050509392505050565b60007001000000000000000000000000000000008210610657576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401808060200182810382526027815260200180610cd66027913960400191505060405180910390fd5b819050919050565b60008060608673ffffffffffffffffffffffffffffffffffffffff16868686604051602401808473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200182815260200193505050506040516020818303038152906040527f23b872dd000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19166020820180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff83818316178352505050506040518082805190602001908083835b602083106107a45780518252602082019150602081019050602083039250610781565b6001836020036101000a0380198251168184511680821785525050505050509050019150506000604051808303816000865af19150503d8060008114610806576040519150601f19603f3d011682016040523d82523d6000602084013e61080b565b606091505b509150915060008082511480610843575081806020019051602081101561083157600080fd5b81019080805190602001909291905050505b905082801561084f5750805b9350505050949350505050565b600061089e83836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f7700008152506109b1565b905092915050565b6108ae610c7b565b6040518060800160405280600063ffffffff1681526020018561ffff168152602001846fffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff168152509050606061090f82610a71565b905061091c600182610b61565b8273ffffffffffffffffffffffffffffffffffffffff168561ffff163373ffffffffffffffffffffffffffffffffffffffff167fb6866b029f3aa29cd9e2bff8159a8ccaa4389f7a087c710968e0b200c0c73b088760405180826fffffffffffffffffffffffffffffffff166fffffffffffffffffffffffffffffffff16815260200191505060405180910390a45050505050565b6000838311158290610a5e576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004018080602001828103825283818151815260200191508051906020019080838360005b83811015610a23578082015181840152602081019050610a08565b50505050905090810190601f168015610a505780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b5060008385039050809150509392505050565b6060600060e01b82602001518360400151846060015160405160200180857bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19167bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191681526004018461ffff1661ffff1660f01b8152600201836fffffffffffffffffffffffffffffffff166fffffffffffffffffffffffffffffffff1660801b81526010018273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1660601b81526014019450505050506040516020818303038152906040529050919050565b600080905060008090507fd0943372c08b438a88d4b39d77216901079eda9ca59d45349841c099083b68303382868686604051808673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018567ffffffffffffffff1667ffffffffffffffff168152602001846007811115610bed57fe5b60ff16815260200180602001838152602001828103825284818151815260200191508051906020019080838360005b83811015610c37578082015181840152602081019050610c1c565b50505050905090810190601f168015610c645780820380516001836020036101000a031916815260200191505b50965050505050505060405180910390a150505050565b6040518060800160405280600063ffffffff168152602001600061ffff16815260200160006fffffffffffffffffffffffffffffffff168152602001600073ffffffffffffffffffffffffffffffffffffffff168152509056fe53616665436173743a2076616c756520646f65736e27742066697420696e203132382062697473a265627a7a72315820f295f20ec231a04e2b6080b70760e194fbfd2ae1e6984ea4e8aa41e41e20e4fc64736f6c63430005110032";
